import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ScrEnvironment } from 'src/environments/environment';
import { Partner } from '../models/partner.model';
import { WITHCRED, WithCredNoCache } from './authentication.service';
import { IScrBaseResponse, ScrBaseService } from './base.service';
import { ScrServiceManager } from './servicemanager.service';
import { PartnerType, VetStatus } from '../models/constants';

export interface PartnerListResponse extends IScrBaseResponse {
  partners: Partner[];

}
export class PartnerDeleteRequest {
  partnerId = 0;
  partnerType = '';
}


export interface PartnerListDetailsResponse extends IScrBaseResponse {
  partnerList: {
    partners: Partner[];
    badgeCount: number;
  }
}

export interface PartnerWithScIds {
  partner: Partner;
  scIds: number[];
}

export interface PreDeletePartnerData extends IScrBaseResponse {
  preDeletePartnerData: preDeletePartnerData;
 }

export interface preDeletePartnerData {
  numberOfAssociatedCscs: number;
  partnerIsUnassociated: boolean;
  cscsUnassociatedToOtherPartners: string;
  cscsAssociatedToOtherPartners: string;
}

export interface PartnerResponse extends IScrBaseResponse {
  partner: Partner;
  badgeCount?: number;
  scIds?: number[];
  scIdCount?: number;
}

export interface PartnerPreDeleteResponse extends IScrBaseResponse {
  partner: Partner;
  badgeCount?: number;
  scIds?: number[];
  scIdCount?: number;
}

export interface PartnerDetailResponse extends IScrBaseResponse {
  partner: Partner;
  scIds?: number[];
}


export interface VettedEntityResultsResponse extends IScrBaseResponse {
  vetStatus: string;
  vetReportId: number;
  vetDate: string; //ISO
  vetRequestId: string; // number string
  vettedEntity: string; // what vetting company knows the entity by.
  findings?: string[];
  errorCode?: string;
  errorDescription?: string;
}






@Injectable({
  providedIn: 'root'
})
export class PartnerService extends ScrBaseService {

  constructor(
    serviceManager: ScrServiceManager,
    private environment: ScrEnvironment,
    private http: HttpClient) {
    super(serviceManager);

  }

  /**
   * Retrieve brands optionally by vet status.
   * @param vetStatus - optional vet status for filtering of list.
   */
  retrievePartners(vetStatus: VetStatus, partnerType?: PartnerType): Observable<PartnerListResponse> {
    let url = `${this.environment.base}/secure2/partner?status=${vetStatus}&summary=true`;
    if (partnerType) {
      url = url + `&partnerType=${partnerType}`;
    }
    return this.http.get<PartnerListResponse>(url, WithCredNoCache);
  }


  /**
  * Retrieve partners by type, optionally by vet status.
  */
  retrievePartnerListDetails(partnerType=PartnerType.Brand): Observable<PartnerListDetailsResponse> {
    const url = `${this.environment.base}/secure2/partner?partnerType=${partnerType}`;
    return this.http.get<PartnerListDetailsResponse>(url, WithCredNoCache);
  }


  /**
  * Retrieve partner by id.
  */
  retrievePartner(partnerId: number): Observable<PartnerResponse> {
    const url = `${this.environment.base}/secure2/partner/${partnerId}`;
    return this.http.get<PartnerResponse>(url, WithCredNoCache);
  }

  savePartner(partner: Partner): Observable<PartnerResponse> {
    const url = `${this.environment.base}/secure2/partner`;

    const pr = JSON.stringify(partner, ScrBaseService.phoneReplacer);

    if (partner.partnerId)
      return this.http.put<PartnerResponse>(url, pr, WITHCRED);
    else
      return this.http.post<PartnerResponse>(url, pr, WITHCRED);
  }


  getPreDeletePartnerData(partner: Partner): Observable<PreDeletePartnerData> {

    const url = `${this.environment.base}/secure2/partner/predeletedata?partnerId=${partner.partnerId}&partnerType=${partner.partnerType}`;
  
    return this.http.get<PreDeletePartnerData>(url, WithCredNoCache);
   
  }

    deletePartner(partner: Partner): Observable<PartnerResponse> {
   
    const url = `${this.environment.base}/secure2/partner/delete`;
  
    const reqBody = new PartnerDeleteRequest()
    reqBody.partnerId = partner.partnerId;
    reqBody.partnerType = partner.partnerType
      return this.http.post<PartnerResponse>(url, reqBody, WITHCRED);
    }



  /**
  * Retrieve brands optionally by vet status.
  */
  getVettingResults(partnerId: number): Observable<VettedEntityResultsResponse> {
    const url = `${this.environment.base}/secure2/partner/${partnerId}/vetresults`;
    return this.http.get<VettedEntityResultsResponse>(url, WithCredNoCache);

  }

}
